import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";

const notiMessage = new NotiMessage("success");

// URL //
const eachUrl = "clinic/getEach?";
const allUrl = "clinic/get?";
const storeUrl = "clinic/store";
const updateUrl = "clinic/update?";
const deleteUrl = "clinic/delete?";

const state = {
  clinics: [],
  clinic: {},
};
const getters = {};
const mutations = {
  SETS(state, payload) {
    state.clinics = payload.data.data;
  },
  SET(state, payload) {
    state.clinic = payload.data.data;
  },
  ADD(state, payload) {
    state.clinics.push(payload.data.data);
  },
  REMOVE(state, payload) {
    const clinics = state.clinics.filter((item) => item.id != payload.id);
    state.clinics = [...clinics];
  },
};

const actions = {
  async get({ commit }) {
    const response = await Request.get_data(allUrl);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SETS", response);
  },
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SET", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    return false;
  },
  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async delete({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
